import React, { Component } from 'react';
import WelcomeHeader from '../WelcomeHeader';
import blurredBackground from './assets/img/background-blurred.jpg';
import erisLogo from './assets/img/eris.svg';
import resize from './assets/img/resize.svg';
import './styles.scss';

class BadSize extends Component {
	render() {
		return (
			<div
				className="BadSize"
				style={{ backgroundImage: `url(${blurredBackground})` }}
			>
				<WelcomeHeader />
				<div className="BadSize-content">
					<div className="BedSizeMessage">
						<div className="BedSizeMessage-header">
							<img className="BedSizeMessage-logo" src={erisLogo} alt="Eris" />
							<h2 className="BedSizeMessage-title">Business simulation</h2>
						</div>
						<div className={'BedSizeMessage-body'}>
							<img src={resize} alt="" />
							<div>
								We're sorry, the resolution of your device is too low to play
								eris. Please return on eris from a device with at least a
								resolution of 1024x550px
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default BadSize;
